import React from 'react';
import { FaChalkboardTeacher, FaUserFriends, FaLaptopCode, FaGraduationCap, FaQuoteLeft } from 'react-icons/fa';

const features = [
  {
    name: 'Expert Instructors',
    description: 'Our tutors are highly qualified professionals with years of teaching experience.',
    icon: FaChalkboardTeacher,
  },
  {
    name: 'Personalized Learning',
    description: 'Tailored lesson plans designed to meet each student\'s unique needs and learning style.',
    icon: FaUserFriends,
  },
  {
    name: 'Modern Curriculum',
    description: 'Up-to-date course materials aligned with the latest educational standards.',
    icon: FaLaptopCode,
  },
  {
    name: 'Proven Results',
    description: 'Consistent track record of helping students achieve their academic goals.',
    icon: FaGraduationCap,
  },
];

const About = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="relative bg-blue-600">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-700" />
        </div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
            About ExcelHub
          </h1>
          <p className="mt-6 max-w-3xl mx-auto text-xl text-blue-100">
            Empowering students to achieve academic excellence through innovative learning solutions.
          </p>
        </div>
      </div>

      {/* Mission Section */}
      <div className="py-16 bg-white sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base font-semibold text-blue-600 tracking-wide uppercase">Our Mission</h2>
            <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
              Transforming Education, One Student at a Time
            </p>
            <p className="mt-5 max-w-2xl mx-auto text-xl text-gray-500">
              At ExcelHub, we believe that every student has unique potential waiting to be unlocked.
            </p>
          </div>

          {/* Features Grid */}
          <div className="mt-16">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
              {features.map((feature) => (
                <div key={feature.name} className="pt-6">
                  <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8 h-full">
                    <div className="-mt-6">
                      <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white mx-auto">
                        <feature.icon className="h-6 w-6" aria-hidden="true" />
                      </div>
                      <h3 className="mt-4 text-lg font-medium text-gray-900 text-center">{feature.name}</h3>
                      <p className="mt-2 text-base text-gray-500 text-center">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default About;